import { OverlayRef } from '@angular/cdk/overlay';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Inject, InjectionToken, Input, NgIterable, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Calendar } from '@fullcalendar/angular';
import { CONTAINER_DATA } from 'src/app/modules/shared/injector.token';
import { EventModel } from '../../../../../shared/models/event.model';
import { CalendarService } from '../../services/calendar.service';
import * as moment from 'moment';
import { isObjectBindingPattern } from 'typescript';
import { CrudService } from 'src/app/modules/shared/services/crud.service';
import { EventoModel } from '../../../settings/models/evento.model';
import { PageableModel } from 'src/app/modules/shared/models/pageable.model';
import { AuthQuery } from 'src/app/modules/auth/state/auth.query';
import { UserModel } from 'src/app/modules/auth/models/user.model';
import { StringUtils } from 'src/app/modules/shared/utils/string.utils';
import { faUserSecret } from '@fortawesome/free-solid-svg-icons';
import { UserUtils } from 'src/app/modules/shared/utils/user.utils';
import { ColorUtils } from 'src/app/modules/shared/utils/color.utils';
import { ConfirmationService } from 'primeng/api';
import { SnotifyPosition, SnotifyService } from 'ng-snotify';
import { GenereClienteType } from 'src/app/modules/shared/enums/GenereClienteType';

@Component({
  selector: 'app-event-popover',
  templateUrl: './event-popover.component.html',
  styleUrls: ['./event-popover.component.scss']
})
export class EventPopoverComponent implements OnInit {

  errors: HttpErrorResponse | undefined = undefined;
  eventModel = new EventModel();
  overlayRef: OverlayRef;
  calendarApi!: Calendar;
  isLoadingOk = false;
  isLoadingDelete = false;
  selectedTipologiaEvento = new EventoModel();
  utenti: UserModel[] = new Array<UserModel>();
  calendars: any[] = new Array<any>();
  hasToUpdateCalendar = true;
  editMode = true;
  genereClienteType = GenereClienteType;
  secondoCliente = false;

  public user = this.authQuery.auth?.user ?? new UserModel();
  agenzia = this.authQuery.agenzia;

  isLoadingEmitter = new EventEmitter<boolean>();

  constructor(@Inject(CONTAINER_DATA) public data: any, private calendarService: CalendarService,
    private crudService: CrudService<any>, private authQuery: AuthQuery, private confirmationService: ConfirmationService,
    private snotifyService: SnotifyService) {
    const today = new Date();
    const month = today.getMonth();
    const year = today.getFullYear();
    this.eventModel = data.currentEvent;
    this.overlayRef = data.overlayRef;
    this.calendarApi = data.calendarApi;
    this.utenti = data.utenti;
    this.calendars = data.calendars;
    this.hasToUpdateCalendar = data.hasToUpdateCalendar;
  }

  getEmpytModel(): EventoModel {
    return new EventoModel();
  }

  ngOnInit(): void {
    if (this.eventModel.id) {
      this.editMode = false;
    }
    if (this.eventModel.nome2 || this.eventModel.cognome2) {
      this.secondoCliente = true;
    }
    this.selectedTipologiaEvento.oggetto = this.eventModel.eventoOggetto;
    if (this.eventModel.attendees) {
      for (const attendee of this.eventModel.attendees) {
        attendee.name = attendee.email;
        attendee.code = attendee.email;
      }
    }
    this.eventModel.rifImmobile = { name: this.eventModel.rifImmobile, code: this.eventModel.rifImmobile };
    // var tooltip = new Tooltip(info.el, {
    //   title: info.event.extendedProps.description,
    //   placement: 'top',
    //   trigger: 'hover',
    //   container: 'body'
    // });
  }

  placeholders(): any {
    return {
      '%AGENTE_NOME%': this.user?.firstname,
      '%AGENTE_COGNOME%': this.user?.lastname,
      '%AGENTE_USERNAME%': this.getUsername(this.eventModel.creator),
      '%CLIENTE_NOME%': this.eventModel.nome,
      '%CLIENTE_COGNOME%': this.eventModel.cognome,
      '%CLIENTE_CELLULARE%': this.eventModel.cellulare,
      '%LUOGO%': this.eventModel.luogo,
      '%RIF_IMMOBILE%': this.eventModel.rifImmobile,
    };
  }

  filteredCopyCalendars(): NgIterable<any> {
    return this.calendars.filter(c => c.id !== this.eventModel.calendarId);
  }

  selectTipologiaEvento(evento: EventoModel): void {
    this.selectedTipologiaEvento = evento;
  }

  computeTitle(): void {
    if (this.selectedTipologiaEvento.oggetto) {
      this.eventModel.titolo = this.selectedTipologiaEvento.oggetto.replace(/%\w+%/g, (all) => {
        if (typeof this.placeholders()[all] !== 'object') {
          return StringUtils.toTitleCase(this.placeholders()[all] || all);
        }
        if (typeof this.placeholders()[all] === 'object') {
          return StringUtils.toTitleCase(this.placeholders()[all].name || all);
        }
        return all;
      });
    }
  }

  removePlaceholders(s: string): string {
    return s.replace(/%.*%/, '');
  }

  // TODO Put in static file
  insertEventOnCalendar(event: any): void {
    const confermato = Boolean(JSON.parse(event.extendedProperties.shared.confermato));
    if (event.start.hasOwnProperty('date')) {
      this.calendarApi.addEvent({
        id: event.id,
        title: confermato ? 'CONFERMATO - ' + event.summary : event.summary,
        start: moment(event.start?.date.value).startOf('day').toDate() ?? undefined,
        end: moment(event.start?.date.value).endOf('day').toDate() ?? undefined,
        allDay: true,
        backgroundColor: UserUtils.findUserColorByEmail(this.utenti, event.organizer.email),
        borderColor: UserUtils.findUserColorByEmail(this.utenti, event.organizer.email),
        textColor: ColorUtils.getCorrectTextColor(UserUtils.findUserColorByEmail(this.utenti, event.organizer.email)),
        event
      });
    }
    if (event.start.hasOwnProperty('dateTime')) {
      this.calendarApi.addEvent({
        id: event.id,
        title: confermato ? 'CONFERMATO - ' + event.summary : event.summary,
        start: event.start?.dateTime.value ?? undefined,
        end: event.end?.dateTime.value ?? undefined,
        backgroundColor: UserUtils.findUserColorByEmail(this.utenti, event.organizer.email),
        borderColor: UserUtils.findUserColorByEmail(this.utenti, event.organizer.email),
        textColor: ColorUtils.getCorrectTextColor(UserUtils.findUserColorByEmail(this.utenti, event.organizer.email)),
        event
      });
    }
  }

  updateEventOnCalendar(id: any, event: any): void {
    if (this.hasToUpdateCalendar) {
      this.deleteEventOnCalendar(id, event);
      this.insertEventOnCalendar(event);
    }
  }

  deleteEventOnCalendar(id: any, event: EventModel): void {
    const cevent = this.calendarApi.getEventById(id);
    cevent?.remove();
  }

  deleteEvent(): void {
    this.confirmationService.confirm({
      message: 'Sei sicuro di procedere?',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sì',
      rejectLabel: 'No',
      accept: () => {
        this.isLoadingDelete = true;
        this.isLoadingEmitter.emit(true);
        this.calendarService.deleteEvent(this.eventModel).subscribe(
          (event: any) => {
            this.deleteEventOnCalendar(this.eventModel.id, this.eventModel);
            this.overlayRef.detach();
          },
          error => {
            this.showNotification();
            this.errors = error;
            console.error(error);
            this.updatePosition();
          },
          () => {
            this.isLoadingDelete = false;
            this.isLoadingEmitter.emit(false);
          });
      },
      reject: () => {
      }
    });
  }

  copyEventTo(calendarId: string): void {
    this.calendarService.copyEventTo(this.eventModel, calendarId).subscribe(
      (event: any) => {
        this.insertEventOnCalendar(event);
      },
      error => {
        this.showNotification();
        this.errors = error;
        console.error(error);
        this.updatePosition();
      },
      () => {
        this.isLoadingDelete = false;
        this.isLoadingEmitter.emit(false);
      });
  }

  onSubmit(): void {
    this.isLoadingOk = true;
    this.isLoadingEmitter.emit(true);
    this.errors = undefined;
    this.eventModel.eventoOggetto = this.selectedTipologiaEvento.oggetto;
    if (!this.secondoCliente && (this.eventModel.nome2 || this.eventModel.cognome2)) {
      this.eventModel.nome2 = '';
      this.eventModel.cognome2 = '';
      this.eventModel.cellulare2 = '';
      this.eventModel.sig2 = '';
    }
    // Event dows not exits, create it
    this.eventModel.titolo = this.removePlaceholders(this.eventModel.titolo);
    if (!this.eventModel.id) {
      this.eventModel.calendarId = this.eventModel.creator;
      this.calendarService.insertEvent(this.eventModel).subscribe(
        (event: any) => {
          this.insertEventOnCalendar(event);
          this.overlayRef.detach();
        },
        error => {
          this.showNotification();
          this.isLoadingOk = false;
          this.isLoadingEmitter.emit(false);
          this.errors = error;
          console.error(error);
          this.updatePosition();
        },
        () => {
          this.isLoadingOk = false;
          this.isLoadingEmitter.emit(false);
        });
    }
    // event already exist, patch it
    else {
      this.calendarService.patchEvent(this.eventModel).subscribe(
        (event: any) => {
          this.updateEventOnCalendar(this.eventModel.id, event);
          this.overlayRef.detach();
        },
        error => {
          this.showNotification();
          this.isLoadingOk = false;
          this.isLoadingEmitter.emit(false);
          this.errors = error;
          console.error(error);
          this.updatePosition();
        },
        () => {
          this.isLoadingOk = false;
          this.isLoadingEmitter.emit(false);
        });
    }

  }

  showNotification(): void {
    this.snotifyService.error('Non è stato possibile procedere alla creazione dell\'evento, riprova più tardi', {
      timeout: 2000,
      showProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      position: SnotifyPosition.rightTop
    });
  }

  findUserColor(email: string) {
    return UserUtils.findUserColorByEmail(this.utenti, email);
  }

  toggleEditMode() {
    this.editMode = !this.editMode;
    this.updatePosition();
  }

  updatePosition() {
    setTimeout(() => {
      // this.overlayRef.updatePositionStrategy(this.overlayRef.getConfig().positionStrategy!)
      this.overlayRef.updatePosition();
    }, 1);
  }

  getUsername(email: string) {
    return UserUtils.findUserFieldByEmail(this.utenti, email, 'username');
  }

}
